const ErrorMessages = {
    scemasMax: num => `* Must be ${num} characters or less`,
    scemasMin: num => `* Must be ${num} characters or more`,
}

export default ErrorMessages;